<template>
  <div>
    <section class="">
      <div class="container">
        <ul class="btn-box">
          <li>
            <router-link :to="{ name: 'MemberInfo' }" tag="button">
              <img src="img/member-icon-1.svg" alt="" />
              {{ $t("會員資料") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'OrderList' }" tag="button">
              <img src="img/member-icon-2.svg" alt="" />
              {{ $t("我的套票") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'CardInfo' }" tag="button" class="active">
              <img src="img/member-icon-6.svg" alt="" />
              {{ $t("卡片資料") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'Coupon' }" tag="button">
              <img src="img/member-icon-8.svg" alt="" />
              {{ $t("套票兌換") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'TradeRecord' }" tag="button">
              <img src="img/member-icon-4.svg" alt="" />
              {{ $t("卡片交易紀錄") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'CarbonReduction' }" tag="button">
              <img src="img/member-icon-9.png" alt="" />
              {{ $t("減碳計算") }}
            </router-link>
          </li>
          <li></li>
        </ul>
        <div class="main" v-if="CardInfoData != null && CardInfoData.CardStatusCode == 1">
          <!-- 0622 新增 bg-box -->
          <div class="bg-box">
            <h1>{{ $t("卡片掛失") }}</h1>
          </div>
          <div class="bg-box">
            <!-- 0622 刪除 -->
            <!-- <h1>卡片掛失</h1> -->
            <!-- <hr> -->
            <ul class="text-box">
              <li>
                <div>
                  <label for="ident">{{ $t("身份證號") }}</label>
                </div>
                <div>
                  <input type="text" class="form-control" id="ident" v-model="ident" :placeholder="$t('請輸入您的身份證號')"
                    maxlength="20" />
                </div>
              </li>
              <li>
                <div>
                  <label for="birth">{{ $t("出生年月日") }}</label>
                </div>
                <div>
                  <input class="form-control" type="date" id="birth" v-model="birth" />
                </div>
              </li>
              <li v-show="CardInfoData.CanTransfer">
                <div>
                  <label for="birth">{{ $t("掛失類型") }}</label>
                </div>
                <div>
                  <!-- <div
                    style="
                      width: 190px;
                      margin-right: 0px;
                      display: flex;
                      justify-content: center;
                      border: 1px solid #173042;
                      border-radius: 5px;
                    "
                  >
                    <button
                      style="
                        width: 100%;
                        background-color: transparent;
                        border: none;
                        border-radius: 3px;
                        padding: 2px 0;
                      "
                      :style="lostType == 0 ? 'background-color: #173042; color: #fff;' : ''"
                      @click="lostType = 0"
                    >
                      {{ $t("僅掛失") }}
                    </button>
                    <button
                      style="
                        width: 100%;
                        background-color: transparent;
                        border: none;
                        border-radius: 3px;
                        padding: 2px 0;
                      "
                      :style="lostType == 1 ? 'background-color: #173042; color: #fff;' : ''"
                      @click="lostType = 1"
                    >
                      {{ $t("掛失並轉移") }}
                    </button>
                  </div> -->
                  <select class="form-control" id="lostType" v-model="lostType">
                    <option value="1" selected>{{ $t("月票轉移至新卡續用") }}</option>
                    <option value="0">
                      {{ $t("僅掛失，月票不續用") }}
                    </option>
                  </select>
                </div>
              </li>
              <li v-show="CardInfoData.CanTransfer && lostType == 1">
                <div>
                  <label for="birth">{{ $t("卡片背面號碼") }}</label>
                </div>
                <div>
                  <input type="text" class="form-control" placeholder="" id="cardNo" v-model="cardNo" />
                </div>
              </li>
              <li v-show="CardInfoData.CanTransfer && lostType == 1">
                <div>
                  <label for="birth">{{ $t("畢業年份") }}</label>
                </div>
                <div>
                  <select class="form-control" id="expire" v-model="expire">
                    <option value="-1">
                      {{ $t("請選擇") }}
                    </option>
                    <option v-for="n in 10" :key="n">
                      {{ parseInt(currentYear) + (n - 1) }}
                    </option>
                  </select>
                </div>
              </li>
              <hr />
            </ul>
            <p class="notice-box">
              {{ $t("1. 填寫的資料須和您申辦時的資料一致。") }}
              <br />
              {{ $t("2. 限完成記名之卡片適用本功能。") }}
              <br />
              <span>{{
                $t("3. 數位學生證不適用本功能，請向學校辦理掛失。")
              }}</span>
              <br />
              {{ $t("4. 確認掛失後即無法取消。") }}
              <br />
              {{ $t("5. 選擇掛失轉移月票，請填入新卡卡號。") }}
            </p>
          </div>
          <div class="done-btn">
            <button @click="sendCardLost()">{{ $t("提交") }}</button>
          </div>
        </div>
      </div>
    </section>
    <!-- 底部加高 底部固定選單fixed的高度 -->
    <div class="nav-menu-bg"></div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import AES from "@/utils/aes.js";
import CryptoJS from "crypto-js";
import VueI18n from "vue-i18n";
import VueTelInput from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
import Storage from "@/utils/storage.js";

Vue.use(VueTelInput, {
  autoDefaultCountry: true,
  defaultCountry: 886,
  dropdownOptions: {
    showDialCodeInSelection: true,
  },
  inputOptions: {
    placeholder: "",
  },
});
Vue.use(VueAxios, axios);
Vue.use(VueI18n);

// this.$t("立即購買")
const messages = {
  zh_tw: {
    "會員資料": "會員資料",
    "我的套票": "我的套票",
    "卡片資料": "卡片資料",
    "套票兌換": "套票兌換",
    "卡片交易記錄": "卡片交易記錄",
    "其他資訊": "其他資訊",
    "卡片掛失": "卡片掛失",
    "身份證號": "身份證號",
    "請輸入您的身份證號": "請輸入您的身份證號",
    "出生年月日": "出生年月日",
    "1. 填寫的資料須和您申辦時的資料一致。": "1. 填寫的資料須和您申辦時的資料一致。",
    "2. 限完成記名之卡片適用本功能。": "2. 限完成記名之卡片適用本功能。",
    "3. 數位學生證不適用本功能，請向學校辦理掛失。": "3. 數位學生證不適用本功能，請向學校辦理掛失。",
    "4. 確認掛失後即無法取消。": "4. 確認掛失後即無法取消。",
    "5. 選擇掛失轉移月票，請填入新卡卡號。": "5. 選擇掛失轉移月票，請填入新卡卡號。",
    "提交": "提交",
    "錯誤": "錯誤",
    "提交失敗, 請稍後再試一次": "提交失敗, 請稍後再試一次",
    "確定": "確定",
    "提交成功，若需要繼續使用，請重新購買MeN Go卡": "提交成功，若需要繼續使用，請重新購買MeN Go卡",
    "卡片交易紀錄": "卡片交易紀錄",
    "減碳計算": "減碳計算",
    "提交成功": "提交成功",
    "請致電客服人員協助處理<br />1. 月票結算<br />2. 新卡綁定": "請致電客服人員協助處理<br />1. 月票結算<br />2. 新卡綁定",
    "僅掛失，月票不續用": "僅掛失，月票不續用",
    "月票轉移至新卡續用": "月票轉移至新卡續用",
  },
  en: {
    "會員資料": "Member info",
    "我的套票": "My pass",
    "卡片資料": "Card info",
    "套票兌換": "Redeem pass",
    "卡片交易記錄": "Card record",
    "其他資訊": "Other info",
    "卡片掛失": "Card loss",
    "身份證號": "ID No.",
    "請輸入您的身份證號": "Please enter your ID No.",
    "出生年月日": "Date of birth",
    "1. 填寫的資料須和您申辦時的資料一致。": "1. The information filled in must be the same as when applying.",
    "2. 限完成記名之卡片適用本功能。": "2. Only the cards that have completed the real-name registration can apply loss online.",
    "3. 數位學生證不適用本功能，請向學校辦理掛失。": "3. When digital student ID card lost, you should report the loss to the school.",
    "4. 確認掛失後即無法取消。": "4. It cannot be canceled after confirmation of loss.",
    "5. 選擇掛失轉移月票，請填入新卡卡號。": "5. Transfer the monthly pass need to fill in the new card number.",
    "提交": "Submit",
    "錯誤": "Error",
    "提交失敗, 請稍後再試一次": "Failed to submit. Please try again.",
    "確定": "Confirm",
    "提交成功，若需要繼續使用，請重新購買MeN Go卡": "Submitted. If you need to continue using it, please purchase a new MeN Go Card.",
    "卡片交易紀錄": "Activity",
    "減碳計算": "Carbon Reduced",
    "提交成功": "Request Submitted successfully",
    "請致電客服人員協助處理<br />1. 月票結算<br />2. 新卡綁定": "Please call our Customer Service for assistance<br />1. Monthly Pass settlement<br />2. Set up New Card",
    "僅掛失，月票不續用": "No need to transfer Monthly Pass",
    "月票轉移至新卡續用": "Monthly Pass transfer needed",
  },
  jp: {
    "會員資料": "會員資料",
    "我的套票": "我的套票",
    "卡片資料": "卡片資料",
    "套票兌換": "套票兌換",
    "卡片交易記錄": "卡片交易記錄",
    "其他資訊": "其他資訊",
    "卡片掛失": "卡片掛失",
    "身份證號": "身份證號",
    "請輸入您的身份證號": "請輸入您的身份證號",
    "出生年月日": "出生年月日",
    "1. 填寫的資料須和您申辦時的資料一致。": "1. 填寫的資料須和您申辦時的資料一致。",
    "2. 限完成記名之卡片適用本功能。": "2. 限完成記名之卡片適用本功能。",
    "3. 數位學生證不適用本功能，請向學校辦理掛失。": "3. 數位學生證不適用本功能，請向學校辦理掛失。",
    "4. 確認掛失後即無法取消。": "4. 確認掛失後即無法取消。",
    "5. 選擇掛失轉移月票，請填入新卡卡號。": "5. 選擇掛失轉移月票，請填入新卡卡號。",
    "提交": "提交",
    "錯誤": "錯誤",
    "提交失敗, 請稍後再試一次": "提交失敗, 請稍後再試一次",
    "確定": "確定",
    "提交成功，若需要繼續使用，請重新購買MeN Go卡": "提交成功，若需要繼續使用，請重新購買MeN Go卡",
    "卡片交易紀錄": "卡片交易紀錄",
    "減碳計算": "減碳計算",
    "提交成功": "提交成功",
    "請致電客服人員協助處理<br />1. 月票結算<br />2. 新卡綁定": "請致電客服人員協助處理<br />1. 月票結算<br />2. 新卡綁定",
    "僅掛失，月票不續用": "僅掛失，月票不續用",
    "月票轉移至新卡續用": "月票轉移至新卡續用",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "CardLost",
  i18n,
  data() {
    return {
      CardInfoData: {},
      countryCallingCode: "",
      number: "",
      valid: false,
      vtiProps: {
        disabled: false,
      },
      lostType: 1,
      currentYear:
        new Date().getMonth() >= 10
          ? new Date().getFullYear() + 1
          : new Date().getFullYear(),
      expire: -1,
      cardNo: "",
      ident: "",
      birth: "",
      IsTester: false,
    };
  },
  watch: {
    ident(newValue, oldValue) {
      var rules = new RegExp(/[^A-Z0-9]/g);
      if (rules.test(newValue)) {
        this.$nextTick(() => {
          this.ident = newValue.replace(rules, '');
        })
      }
    }
  },
  created: function () {
    let that = this;
    Vue.axios
      .get(
        this.GLOBAL.apiSrc + this.GLOBAL.subDirectory + "/Htmlv2/CardLostInit",
        {
          params: {
            token: Storage.get("ek_login_token"),
          },
        }
      )
      .then((response) => {
        this.CardInfoData = response.data.CardInfoData;
        this.IsTester = response.data.IsTester;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  updated: function () { },
  mounted: function () {
    // 回頂端
    $(window).scrollTop(0);
    // 套用Class
    $(".wrapper").addClass("member");
    $(".wrapper").addClass("member-card-information");
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
    }
  },
  methods: {
    onInput(phone, phoneObject, input) {
      this.countryCallingCode = phoneObject.countryCallingCode;
      this.number = phoneObject.number;
      this.valid = phoneObject.valid;
    },
    sendCardLost() {
      // 顯示請稍候
      this.$swal({
        heightAuto: false,
        title: this.$t("請稍候..."),
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: function () {
          this.$swal.showLoading();
        },
      });
      if (this.ident == "") {
        this.$swal({
          heightAuto: false,
          title: this.$t("錯誤"),
          text: "請填寫身份證號",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: this.$t("確定"),
        });
        return;
      }
      if (this.birth == "") {
        this.$swal({
          heightAuto: false,
          title: this.$t("錯誤"),
          text: "請填寫出生年月日",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: this.$t("確定"),
        });
        return;
      }
      if (this.CardInfoData.CanTransfer && this.lostType == 1 && this.cardNo == "") {
        this.$swal({
          heightAuto: false,
          title: this.$t("錯誤"),
          text: "請填寫卡片背面號碼",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: this.$t("確定"),
        });
        return;
      }
      if (
        this.lostType == 1 &&
        this.cardNo.startsWith("15") &&
        this.expire == -1
      ) {
        this.$swal({
          heightAuto: false,
          title: this.$t("錯誤"),
          text: "請選擇畢業年份",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: this.$t("確定"),
        });
        return;
      }
      let that = this;
      $.ajax({
        url: that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/CardLost",
        type: "post",
        data: {
          token: Storage.get("ek_login_token"),
          ident: $.trim(that.ident),
          birth: that.birth,
          lostType: that.CardInfoData.CanTransfer ? that.lostType : 0,
          cardNo: $.trim(that.cardNo),
          expire: that.expire,
        },
        dataType: "json",
        error: function () {
          that.$swal({
            heightAuto: false,
            title: that.$t("錯誤"),
            text: that.$t("提交失敗, 請稍後再試一次"),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: that.$t("確定"),
          });
        },
        success: function (res) {
          // 判斷結果
          if (res.ok) {
            if (res.transfer) {
              that.$swal({
                heightAuto: false,
                icon: "success",
                title: that.$t("轉移完成"),
                html: that.$t("請前往設備重新過卡"),
                confirmButtonText: that.$t("確認"),
                willClose: function () {
                  // 回到首頁
                  that.$router.push({
                    name: "Home",
                    params: {},
                  });
                },
                allowOutsideClick: false,
              });
            } else {
              that.$swal({
                heightAuto: false,
                icon: "success",
                title: that.$t("提交成功"),
                html: that.$t(
                  "請致電客服人員協助處理<br />1. 月票結算<br />2. 新卡綁定"
                ),
                confirmButtonText: that.$t("確認"),
                willClose: function () {
                  // 回到首頁
                  that.$router.push({
                    name: "Home",
                    params: {},
                  });
                },
                allowOutsideClick: false,
              });
            }
          } else if (res.error_msg) {
            var error_msg = JSON.parse(res.error_msg);
            if (res.toekn_error) {
              that.$swal({
                heightAuto: false,
                title: that.$t("錯誤"),
                text: error_msg[i18n.locale],
                icon: "error",
                allowOutsideClick: false,
                confirmButtonText: that.$t("確定"),
                willClose: function () {
                  // 移除登入資訊
                  Storage.remove("ek_login_token");
                  // 回到首頁
                  that.$router.push({
                    name: "Home",
                    params: {},
                  });
                },
              });
            } else {
              that.$swal({
                heightAuto: false,
                title: that.$t("錯誤"),
                text: error_msg[i18n.locale],
                icon: "error",
                allowOutsideClick: false,
                confirmButtonText: that.$t("確定"),
              });
            }
          }
        },
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/CardLost.vue